export const MINIGAME_COOLDOWN_MS = 5 * 60_000;

export function isCooldownActive(lastAt: number, nowMs: number): boolean {
  if (lastAt === 0) return false;
  return nowMs - lastAt < MINIGAME_COOLDOWN_MS;
}

export function cooldownRemaining(lastAt: number, nowMs: number): number {
  if (lastAt === 0) return 0;
  return Math.max(0, MINIGAME_COOLDOWN_MS - (nowMs - lastAt));
}
